import React, { useEffect, useState } from 'react';
import axiosApi from '../Utils/axiosApi';
import {
  Button,
  Checkbox,
  FormControlLabel,
  CircularProgress,
} from '@mui/material';
import './HostelDetails.css';
import HotelIcon from '@mui/icons-material/Hotel';
import CloseIcon from '@mui/icons-material/Close';
import BookingFormDialog from './BookingFormDialog';
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
const HostelDetails = ({ hostelId }) => {
  const [activeTab, setActiveTab] = useState('overview');
  const [showBookingForm, setShowBookingForm] = useState(false);
  const [loading, setLoading] = useState(true);
  const [menuLoading, setMenuLoading] = useState(false);
  const [menuFetched, setMenuFetched] = useState(false);
  const [hostelInfo, setHostelInfo] = useState({});
const location = useLocation();
const [searchDates, setSearchDates] = useState({
  checkIn: "",
  checkOut: "",
});
  // Fetch hostel info
useEffect(() => {
  setLoading(true);

  const params = new URLSearchParams(location.search);
  const checkIn = params.get("searchCheckInDate");
  const checkOut = params.get("searchCheckOutDate");

  axiosApi
    .post('/public/getHostelInfo', {
      hostelSearchCriteria: {
        hostelIds: [hostelId],
        searchCheckInDate: checkIn || null,
        searchCheckOutDate: checkOut || null,
      },
    })
    .then((res) => {
      const dto = res.data;

      const rooms =
        dto.hostelRoomDTOs?.map((room) => ({
          type: room.roomType,
          capacity: room.totalCapacity,
          dailyPrice: room.dailyPrice,
          monthlyPrice: room.monthlyPrice,
          description: room.description,
          availabilityCount: room.availabilityCount,
        })) || [];

      setHostelInfo({
        name: dto.hostelName,
        overview: dto.hostelOverview,
        city: dto.cityName,
        state: dto.stateName,
        country: dto.countryName,
        phone: dto.phoneNumber,
        mobile: dto.mobileNumber,
        facilities: dto.hostelFacilityDTO || {},
        rules: dto.hostelRuleDTO?.hostelRuleDescription || '',
        rooms,
        foodPrice: dto.foodPrice,
		menuType: dto.menuType,
        imageFileNames: dto.imageFileNames || [],
		menuDetails: null,
  standardMenu: null,
      });
	  setSearchDates({
  checkIn: checkIn || "",
  checkOut: checkOut || "",
});
    })
    .finally(() => setLoading(false));
}, [hostelId, location.search]);

  // Fetch menu details when tab is opened
useEffect(() => {
  if (activeTab !== 'menu-details' || menuFetched) return;

  setMenuLoading(true);

  const menuRequest =
    hostelInfo.menuType === 'STANDARD'
      ? axiosApi.post('/public/getHostelStandardMenu', {
          hostelIds: [hostelId],
        })
      : axiosApi.post('/public/getHostelMenu', {
          hostelIds: [hostelId],
        });

  Promise.all([
    menuRequest,
    axiosApi.post('/public/getMenuFoodCost', {
      hostelIds: [hostelId],
    }),
  ])
    .then(([menuRes, costRes]) => {
      let foodCost = null;

      if (Array.isArray(costRes.data) && costRes.data.length > 0) {
        const cost = costRes.data[0];

        foodCost = {
          oneDay: cost.foodPricePerDay ?? '',
          oneMonth: cost.foodPricePerMonth ?? '',
        };
      }

      // STANDARD MENU
      if (hostelInfo.menuType === 'STANDARD') {
        const standardMenu =
          Array.isArray(menuRes.data) && menuRes.data.length > 0
            ? menuRes.data[0]
            : null;

        setHostelInfo((prev) => ({
          ...prev,
          standardMenu,
          foodCost,
        }));
      }
      // WEEKLY MENU
      else {
        const menuByDay = {};

        (menuRes.data || []).forEach((item) => {
          const day = item.dayOfWeek?.toLowerCase();

          if (day) {
            menuByDay[day] = {
              breakfast: item.breakfastItems,
              lunch: item.lunchItems,
              snacks: item.snacksItems,
              dinner: item.dinnerItems,
            };
          }
        });

        setHostelInfo((prev) => ({
          ...prev,
          menuDetails: menuByDay,
          foodCost,
        }));
      }

      setMenuFetched(true);
    })
    .catch((err) => {
      console.error('Error loading menu:', err);
    })
    .finally(() => {
      setMenuLoading(false);
    });
}, [
  activeTab,
  menuFetched,
  hostelId,
  hostelInfo.menuType,
]);

const renderFoodItems = (items) => {
  if (!items) return <p>Not Provided</p>;

  return (
    <div className="food-items">
      {items
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean)
        .map((item, index) => (
          <span key={index} className="food-chip">
            {item}
          </span>
        ))}
    </div>
  );
};

  const renderContent = () => {
    if (loading) return <CircularProgress />;

    switch (activeTab) {
      case 'overview':
  return (
    <div className="tab-section">
      <div className="section-header">
        <span>🏠</span>
        <h2>Overview</h2>
      </div>

      <div className="info-card">
        <p>{hostelInfo.overview}</p>
      </div>

      <div className="info-card">
        <h3>Contact Information</h3>

        <div className="info-row">
          <strong>📱 Mobile:</strong> {hostelInfo.mobile}
        </div>

        <div className="info-row">
          <strong>☎️ Phone:</strong> {hostelInfo.phone}
        </div>

        <div className="info-row">
          <strong>📍 Location:</strong> {hostelInfo.city}, {hostelInfo.state}, {hostelInfo.country}
        </div>
      </div>
    </div>
  );

      case 'facilities':
  return (
    <div className="tab-section">
      <div className="section-header">
        <span>🏢</span>
        <h2>Facilities</h2>
      </div>

      <div className="facilities-grid">
        {Object.entries(hostelInfo.facilities || {})
          .filter(([key]) =>
            !['id', 'changeUserName', 'changeTimeStamp', 'version'].includes(key)
          )
          .map(([key, value]) => (
            <div key={key} className="facility-card">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={(value || '').toLowerCase() === 'true'}
                    disabled
                  />
                }
                label={key}
              />
            </div>
          ))}
      </div>
    </div>
  );

case 'house-rules':
  return (
    <div className="tab-section">
      <div className="section-header">
        <span>📋</span>
        <h2>House Rules</h2>
      </div>

      <div className="rules-card">
        <pre className="hostel-rules-text">
          {typeof hostelInfo?.rules === 'string' &&
          hostelInfo.rules.trim().length > 0
            ? hostelInfo.rules.trim().replace(/\n\s*\n+/g, '\n')
            : 'No rules available'}
        </pre>
      </div>
    </div>
  );
case 'room-details':
  return (
    <div className="tab-section">
      <div className="section-header">
        <span>🛏️</span>
        <h2>Room Details</h2>
      </div>

      {hostelInfo.rooms?.map((room) => (
        <div className="room-card" key={room.type}>
          <div className="room-header">
            <h3>{room.type}</h3>

            {room.availabilityCount > 0 ? (
              <span style={{ color: 'green', fontWeight: 600 }}>
                {room.availabilityCount} Available
              </span>
            ) : (
              <span style={{ color: 'red', fontWeight: 600 }}>
                Fully Booked
              </span>
            )}
          </div>

          <div className="room-price">
            <div className="price-chip">
              ₹{room.dailyPrice}/Day
            </div>

            <div className="price-chip">
              ₹{room.monthlyPrice}/Month
            </div>
          </div>

          <div className="room-info">
  <strong>Capacity:</strong> {room.capacity}
</div>

{room.description && (
  <div className="room-description">
    {room.description}
  </div>
)}
        </div>
      ))}
    </div>
  );

      case 'menu-details':
  if (menuLoading) return <CircularProgress />;

  // STANDARD MENU
  if (hostelInfo.menuType === 'STANDARD') {
    const menu = hostelInfo.standardMenu;

    if (!menu) {
      return <p>No menu available</p>;
    }

    return (
      <>
      <div className="menu-section-header">
  <span>🍽</span>
  <h2>Standard Menu</h2>
</div>

<div className="standard-menu-container">
  <div className="meal-card breakfast">
    <div className="meal-header">
      <span>🌅</span>
      <h3>Breakfast</h3>
    </div>
    {renderFoodItems(menu.breakfast)}
  </div>

  <div className="meal-card lunch">
    <div className="meal-header">
      <span>☀️</span>
      <h3>Lunch</h3>
    </div>
    {renderFoodItems(menu.lunch)}
  </div>

  <div className="meal-card snacks">
    <div className="meal-header">
      <span>☕</span>
      <h3>Snacks</h3>
    </div>
    {renderFoodItems(menu.snacks)}
  </div>

  <div className="meal-card dinner">
    <div className="meal-header">
      <span>🌙</span>
      <h3>Dinner</h3>
    </div>
    {renderFoodItems(menu.dinner)}
  </div>
</div>

        {hostelInfo.foodCost && (
          <div className="food-cost-card">
            <h3>Food Cost</h3>
            <p>
              <strong>Per Day:</strong> ₹{hostelInfo.foodCost.oneDay || 'N/A'}
            </p>
            <p>
              <strong>Per Month:</strong> ₹{hostelInfo.foodCost.oneMonth || 'N/A'}
            </p>
          </div>
        )}
      </>
    );
  }

  // NORMAL WEEKLY MENU
  if (!hostelInfo.menuDetails) {
    return <p>No menu available</p>;
  }

  return (
    <>
      <div className="menu-section-header">
  <span>📅</span>
  <h2>Weekly Menu</h2>
</div>

      <div className="weekly-menu-container">
  {Object.entries(hostelInfo.menuDetails).map(([day, meals]) => (
    <div className="weekly-day-card" key={day}>
      <div className="weekly-day-header">
        {day.charAt(0).toUpperCase() + day.slice(1)}
      </div>

      <div className="meal-row">
        <strong>🌅 Breakfast</strong>
        {renderFoodItems(meals.breakfast)}
      </div>

      <div className="meal-row">
        <strong>🍛 Lunch</strong>
        {renderFoodItems(meals.lunch)}
      </div>

      <div className="meal-row">
        <strong>☕ Snacks</strong>
        {renderFoodItems(meals.snacks)}
      </div>

      <div className="meal-row">
        <strong>🌙 Dinner</strong>
        {renderFoodItems(meals.dinner)}
      </div>
    </div>
  ))}
</div>
    </>
  );

      default:
        return null;
    }
  };


  return (
    <div className="hostel-details">
	<Helmet>
  <title>
    {hostelInfo.name
      ? `${hostelInfo.name} Hostel in ${hostelInfo.city || ''} | HostelandPG`
      : 'Hostel Details | HostelandPG'}
  </title>

  <meta
    name="description"
    content={
      hostelInfo.name
        ? `Book ${hostelInfo.name} hostel in ${hostelInfo.city || ''}. Check rooms, facilities, food, pricing and availability on HostelandPG.`
        : 'Explore hostel details, rooms, pricing and facilities on HostelandPG.'
    }
  />

  <link
    rel="canonical"
    href={`https://www.hostelandpg.com/hostel/${hostelId}`}
  />

  <meta
    property="og:title"
    content={hostelInfo.name || 'Hostel Details'}
  />

  <meta
    property="og:description"
    content={hostelInfo.overview || 'View hostel details on HostelandPG'}
  />
</Helmet>
      <div className="hostel-details-container">
       {hostelInfo.imageFileNames?.length > 0 && (
  <img
    src={`/images/${hostelInfo.imageFileNames[0]}`}
    alt={`${hostelInfo.name} hostel in ${hostelInfo.city}`}
    loading="lazy"
    className="hostel-image"
  />
)}


        <Button
          onClick={() => setShowBookingForm((p) => !p)}
          variant={showBookingForm ? 'contained' : 'outlined'}
          color={showBookingForm ? 'secondary' : 'primary'}
          startIcon={showBookingForm ? <CloseIcon /> : <HotelIcon />}
          sx={{ mt: 2, borderRadius: 3, textTransform: 'none' }}
        >
          {showBookingForm ? 'Close Booking Form' : 'Book Hostel'}
        </Button>

        <BookingFormDialog
          open={showBookingForm}
          onClose={() => setShowBookingForm(false)}
          hostelId={hostelId}
          hostelInfo={hostelInfo}
		  searchDates={searchDates}
        />

        <div className="tabs">
          {['overview', 'facilities', 'house-rules', 'room-details', 'menu-details'].map((tab) => (
            <button
              key={tab}
              className={activeTab === tab ? 'active' : ''}
              onClick={() => setActiveTab(tab)}
            >
              {tab.replace('-', ' ').replace(/\b\w/g, (l) => l.toUpperCase())}
            </button>
          ))}
        </div>

        <div className="tab-content">{renderContent()}</div>
      </div>
    </div>
  );
};

export default HostelDetails;
